















































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetBingliList,
  EditBingli,
  EditMoshi,
  GetBingliDetail,
  DelBingli,
  CreateModel,
} from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  private keshi: any = ["中医内科", "中医外科", "中医骨伤科"];
  private zhenduan: any = ["高血压", "糖尿病"];
  private leixing: any = ["常规病例", "疑难病例"];
  private zhiye: any = [
    "工人",
    "农民",
    "家庭主妇",
    "私营业主",
    "退休工人",
    "军人",
  ];
  private hunpei: any = ["单身", "离异", "丧偶", "已婚"];
  private jieqi: any = [
    "立春",
    "雨水",
    "惊蛰",
    "春分",
    "清明",
    "谷雨",
    "立夏",
    "小满",
    "芒种",
    "夏至",
    "小暑",
    "大暑",
    "立秋",
    "处暑",
    "白露",
    "秋分",
    "寒露",
    "霜降",
    "立冬",
    "小雪",
    "大雪",
    "冬至",
    "小寒",
    "大寒",
  ];
  private chenshuzhe: any = ["本人", "父母", "子女", "亲戚", "朋友", "其它"];
  private kekaochengdu: any = ["可靠", "基本可靠", "不可靠"];
  private data: any = [];
  private ifShowMoshi: any = false;
  private ifShowEdit: any = false;
  private ifShowZhenci: any = false;
  private addZhenciData: any = {};
  private zhenciOptions: any = [
    {
      名称: "初诊",
      value: 0,
    },
    {
      名称: "二诊",
      value: 1,
    },
    {
      名称: "三诊",
      value: 2,
    },
    {
      名称: "四诊",
      value: 3,
    },
    {
      名称: "五诊",
      value: 4,
    },
    {
      名称: "六诊",
      value: 5,
    },
    {
      名称: "七诊",
      value: 6,
    },
    {
      名称: "八诊",
      value: 7,
    },
    {
      名称: "九诊",
      value: 8,
    },
    {
      名称: "十诊",
      value: 9,
    },
  ];
  private editData: any = {};
  private editCell: any = {
    应用模式: [],
    sex: "",
  };
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private disabledDate: any = this.endDate();
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private goZhenci(d: any, item: any) {
    this.$router.push({
      path: "/main/teacher/resource-zhenci-edit",
      query: {
        type: "修改",
        id: d.medcase_id,
        data: JSON.stringify(item),
      },
    });
  }
  private delOne(item: any) {
    this.$confirm("确定要删除吗？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          medcase_id: item.medcase_id,
        },
      };
      DelBingli(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private addZhenciSure() {
    if (!this.addZhenciData["名称"]) {
      this.$message.warning("请选择需要添加的诊次");
      return;
    }
    // 判断诊次不能重复
    let repeat: any = false;
    this.editCell["诊次"].forEach((ele: any) => {
      if (ele["名称"] == this.addZhenciData["label"]) {
        repeat = true;
      }
    });
    if (repeat) {
      this.$message.warning("当前诊次已存在");
      return;
    }
    this.ifShowZhenci = false;
    this.$router.push({
      path: "/main/teacher/resource-zhenci-edit",
      query: {
        type: "添加",
        id: this.editCell.medcase_id,
        data: JSON.stringify(this.addZhenciData),
      },
    });
  }
  private addZhenci(item: any) {
    this.editCell = JSON.parse(JSON.stringify(item));
    this.addZhenciData = {};
    this.ifShowZhenci = true;
  }
  private yanshi(item: any) {
    if (item["模型状态"] != "可演示") {
      return;
    }
    if (item["模型生成时间"] < item["update_time"]) {
      this.$message.warning("当前病例数据有更新，请更新模型");
      return;
    }
    this.$router.push({
      path: "/main/teacher/resource-chart",
      query: {
        id: item.medcase_id,
      },
    });
  }
  private changeSex(val: any) {
    this.editData["性别"] = val;
    this.$forceUpdate();
  }
  private openEdit(item?: any) {
    if (item) {
      const params: any = {
        params: {
          medcase_id: item.medcase_id,
        },
      };
      GetBingliDetail(this, params).then((res: any) => {
        this.editData = res;
      });
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["病例编号"]) {
      this.$message.warning("请输入病例编号");
      return;
    }
    if (!this.editData["病例科室"]) {
      this.$message.warning("请输入病例科室");
      return;
    }
    if (!this.editData["病例类型"]) {
      this.$message.warning("请选择病例类型");
      return;
    }
    if (!this.editData["病例中医辨病"]) {
      this.$message.warning("请输入病例诊断");
      return;
    }
    if (!this.editData["性别"]) {
      this.$message.warning("请选择性别");
      return;
    }
    if (!this.editData["出生年月"]) {
      this.$message.warning("请选择出生年月");
      return;
    }
    if (!this.editData["职业"]) {
      this.$message.warning("请选择职业");
      return;
    }
    // if (!this.editData["婚配"]) {
    //   this.$message.warning("请选择婚配");
    //   return;
    // }
    // if (!this.editData["发病节气"]) {
    //   this.$message.warning("请选择发病节气");
    //   return;
    // }
    if (!this.editData["病史陈述者"]) {
      this.$message.warning("请选择病史陈述者");
      return;
    }
    if (!this.editData["可靠程度"]) {
      this.$message.warning("请选择可靠程度");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditBingli(this, this.editData, loading)
      .then(() => {
        loading.close();
        const type: any = this.editData.medcase_id ? "编辑" : "添加";
        this.$message.success(type + "成功！");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openMoshi(item: any) {
    this.editCell = JSON.parse(JSON.stringify(item));
    this.ifShowMoshi = true;
  }
  private selectMoshi(val: any) {
    const index = this.editCell["应用模式"].indexOf(val);
    if (index == -1) {
      this.editCell["应用模式"].push(val);
    } else {
      this.editCell["应用模式"].splice(index, 1);
    }
  }
  private openMore(index: any) {
    this.data[index].showMore = true;
    this.$forceUpdate();
  }
  private moshiSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      medcase_id: this.editCell.medcase_id,
      应用模式: this.editCell["应用模式"],
    };
    EditMoshi(this, params, loading)
      .then(() => {
        loading.close();
        this.$message.warning("修改成功");
        this.getList();
        this.ifShowMoshi = false;
      })
      .catch(() => {
        loading.close();
      });
  }
  private createMoxing(item: any) {
    if (item["诊次"].length == 0) {
      this.$message.warning("对不起，您还未添加诊次，不能生成模型！");
      return;
    } else if (item["模型状态"] == "进行中") {
      this.$message.warning("当前模型正在生成中，不能重复生成！");
      return;
    } else {
      if (item["模型生成时间"] < item["update_time"] || !item["模型生成时间"]) {
        let tip: any = "";
        if (item["模型状态"] == "待生成") {
          tip =
            "您确定要生成模型么？请确保该病例数据已经填写准确，否则影响模式生成效果。";
        } else if (item["模型状态"] == "可演示") {
          tip = "确定需要重新生成么？";
        }
        this.$confirm(tip, "温馨提示", {
          customClass: "commonConfirm",
          confirmButtonClass: "iconfont icon-anniu4 confirmSure",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        })
          .then(() => {
            const params: any = {
              medcase_id: item.medcase_id,
            };
            const loading = this.$loading({
              lock: true,
              text: "加载中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            CreateModel(this, params, loading)
              .then(() => {
                loading.close();
                this.getList();
              })
              .catch(() => {
                loading.close();
              });
          })
          .catch((e) => {
            console.log("取消了");
          });
      } else {
        this.$message.warning("当前已是最新模型!");
        return;
      }
    }
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      病例类型: this.filters["病例类型"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("bingliFilter", JSON.stringify(this.filters));
    GetBingliList(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((ele: any) => {
          ele.showMore = false;
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("bingliFilter")) {
      this.filters = JSON.parse(localStorage.getItem("bingliFilter") as any);
    }
    this.getList();
  }
}
